import { CALL_API } from '../api';

export const SOCIAL_LOUNGE_DATA = 'SOCIAL_LOUNGE_DATA';
export const SOCIAL_LOUNGE_AUTO_JOIN_TABLE = 'SOCIAL_LOUNGE_AUTO_JOIN_TABLE';
export const FETCH_SOCIAL_LOUNGE_TABLES = 'FETCH_SOCIAL_LOUNGE_TABLES';

export const FETCH_AIRMEET_TABLE_REQUEST = 'FETCH_AIRMEET_TABLE_REQUEST';
export const FETCH_AIRMEET_TABLE_RESPONSE = 'FETCH_AIRMEET_TABLE_RESPONSE';

export const ADD_TABLE_INVITE = 'ADD_TABLE_INVITE';
export const DELETE_TABLE_INVITE = 'DELETE_TABLE_INVITE';
export const UPDATE_TABLE_INVITE = 'UPDATE_TABLE_INVITE';
export const ACCEPT_TABLE_INVITE = 'ACCEPT_TABLE_INVITE';

export const UPDATE_AIRMEET_TABLE_USER_REQUEST =
    'UPDATE_AIRMEET_TABLE_USER_REQUEST';
export const UPDATE_AIRMEET_TABLE_USER__RESPONSE =
    'UPDATE_AIRMEET_TABLE_USER__RESPONSE';

export const UPDATE_AIRMEET_TABLE_STREAM_STATUS =
    'UPDATE_AIRMEET_TABLE_STREAM_STATUS';
export const UPDATE_AIRMEET_JOINED_TABLE = 'UPDATE_AIRMEET_JOINED_TABLE';

export const UPDATE_SOCIAL_LOUNGE_TABLE_CHAIRS =
    'UPDATE_SOCIAL_LOUNGE_TABLE_CHAIRS';
export const SET_SPEED_NETWORKING_MOUNTED = 'SET_SPEED_NETWORKING_MOUNTED';

export function socialLounge(data) {
    return {
        type: SOCIAL_LOUNGE_DATA,
        payload: data,
    };
}

export function fetchTables(airmeetId) {
    return {
        type: FETCH_SOCIAL_LOUNGE_TABLES,
        payload: {
            airmeetId,
        },
    };
}

export function autoJoinTable({ tableName, chair, userId, lounge, code }) {
    return {
        type: SOCIAL_LOUNGE_AUTO_JOIN_TABLE,
        payload: {
            tableName,
            chair,
            userId,
            lounge,
            code,
        },
    };
}

export function updateTableUser(userId, tableId, position) {
    return {
        [CALL_API]: {
            types: [
                UPDATE_AIRMEET_TABLE_USER_REQUEST,
                UPDATE_AIRMEET_TABLE_USER__RESPONSE,
            ],
            endpoint: `/airmeet/table`,
            body: {
                tableId,
                userId,
                position,
            },
            type: 'json',
            method: 'PUT',
        },
    };
}

export function updateJoinedTableStatus(status) {
    return {
        type: UPDATE_AIRMEET_TABLE_STREAM_STATUS,
        payload: status,
    };
}

export function updateJoinedTable(updatedTable) {
    return {
        type: UPDATE_AIRMEET_JOINED_TABLE,
        payload: updatedTable,
    };
}

export function updateTableChairs(code, chairs) {
    return {
        type: UPDATE_SOCIAL_LOUNGE_TABLE_CHAIRS,
        payload: { code, chairs },
    };
}

export function addTableInvite({ number, userId }) {
    return {
        type: ADD_TABLE_INVITE,
        payload: { number, userId },
    };
}

export function removeTableInvite({ userId }) {
    return {
        type: DELETE_TABLE_INVITE,
        payload: { userId },
    };
}

export function updateTableInvites(data) {
    return {
        type: UPDATE_TABLE_INVITE,
        payload: data,
    };
}

export function acceptTableInvite({ userId }) {
    return {
        type: ACCEPT_TABLE_INVITE,
        payload: { userId },
    };
}
export function setSpeedNetworkingMounted(data) {
    return {
        type: SET_SPEED_NETWORKING_MOUNTED,
        payload: data,
    };
}
